import { FunctionComponent } from 'react';
import { Button } from '@mui/material';

export const HiddenSubmitButton: FunctionComponent = () => (
  <Button sx={{ display: 'none' }} type="submit" hidden>
    Hidden
  </Button>
);
